const ProductSpecManager = {
  init() {
    this.gpoContainer = null;
    this.desktopSpecList = document.querySelector(
      ".custom-spec-lists:not(.mobile)"
    );
    this.mobileSpecList = document.querySelector(".custom-spec-lists.mobile");
    this.processedNames = new Set();
    this.watchForGpoContainer();
  },

  watchForGpoContainer() {
    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.type === "childList") {
          const gpoContainer = document.querySelector(".gpo-container");
          if (gpoContainer) {
            this.gpoContainer = gpoContainer;
            observer.disconnect();
            this.addAttributesSpec();
            this.showElements();
            break;
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Fallback timeout
    setTimeout(() => {
      observer.disconnect();
      console.warn("Timeout: .gpo-container was not found within 15 seconds.");
    }, 15000);
  },

  addAttributesSpec() {
    if (!this.gpoContainer) {
      console.error("gpo-container not found");
      return;
    }
   const customSection = document.querySelector(".custom-options-section");
    if (customSection) {
      customSection.classList.remove("hidden");
    }
    const elementsWithName = this.gpoContainer.querySelectorAll("[name]");
    elementsWithName.forEach((element) => this.processElement(element));
  },

  processElement(element) {
    const name = element.getAttribute("name");
    if (this.processedNames.has(name)) return;
    this.processedNames.add(name);

    const { value, price } = this.getValueAndPrice(element);
    const displayStyle = this.getDisplayStyle(element);

    this.appendSpecElement(name, value, price, displayStyle);
  },

  getValueAndPrice(element) {
    let value = "Not Selected";
    let price = "+ $0.00";

    if (element.type === "radio") {
      const checkedRadio = this.gpoContainer.querySelector(
        `[name="${element.name}"]:checked`
      );
      if (checkedRadio) {
        value = checkedRadio.value;
        price = this.getPriceFromParent(checkedRadio);
      }
    } else if (element.tagName === "SELECT") {
      value = element.value;
      if (value) price = this.getPriceFromGrandparent(element);
    } else if (element.type === "checkbox") {
      value = element.checked;
      if (value) price = this.getPriceFromParent(element);
    } else {
      value = element.value;
      if (value) price = this.getPriceFromParent(element);
    }

    return { value: value || "Not Selected", price: this.formatPrice(price) };
  },

  getPriceFromParent(element) {
    return (
      element
        .closest(".gpo-container")
        ?.querySelector(".addOn")
        ?.textContent.replace(/[()]/g, "") || "+ $0.00"
    );
  },

  getPriceFromGrandparent(element) {
    return (
      element
        .closest(".gpo-container")
        ?.querySelector(".addOn")
        ?.textContent.replace(/[()]/g, "") || "+ $0.00"
    );
  },

  formatPrice(price) {
    return "+" + price.split("+").pop().trim();
  },

  getDisplayStyle(element) {
    return element
      .closest("[data-clo-display]")
      ?.getAttribute("data-clo-display") === "show"
      ? "none"
      : "block";
  },

  appendSpecElement(name, value, price, displayStyle) {
    const elementHTML = `
      <div class="summary_list_items">
        <strong>${name}</strong>
        <span class="value_summary" data-name="${value}">${value}</span>
        <span class="price spec-price" data-name="${value}" data-prev_price="${value}" data-summary_price="${value}">${price}</span>
      </div>
    `;

    this.appendToList(this.desktopSpecList, name, displayStyle, elementHTML);
    this.appendToList(this.mobileSpecList, name, displayStyle, elementHTML);
  },

  appendToList(list, name, displayStyle, html) {
    if (!list) return;

    const element = document.createElement("li");
    element.setAttribute("data-name", name);
    element.style.display = displayStyle;
    element.innerHTML = html;
    list.appendChild(element);
  },

  showElements() {
    document
      .querySelector(".custom-option-container")
      ?.classList.remove("hidden");
    document.querySelector(".glance-build-summary")?.classList.remove("hidden");
  },
};

// Initialize the ProductSpecManager when the DOM is ready
document.addEventListener("DOMContentLoaded", () => ProductSpecManager.init());
